'use client';

import { ReactNode, useState } from 'react';

import { FormCheckbox } from '../../../forms';

export interface IAgreeCheckBoxProps {
  onChange: (flag: boolean) => void;
  text: ReactNode;
}

/**
 * -----------------------------------------------------------------------------
 * It renders the agree checkbox with a text
 * @deprecated
 * TODO: Deprecate this.
 */
export function AgreeCheckBox({
  onChange,
  text,
}: Readonly<IAgreeCheckBoxProps>) {
  const [hasCheckbox, setCheckbox] = useState<boolean>(false);

  const handleOnChange = () => {
    setCheckbox(!hasCheckbox);
    onChange(!hasCheckbox);
  };

  return (
    <div className="flex flex-col items-center gap-2 pb-2 sm:flex-row">
      <FormCheckbox isSelected={hasCheckbox} onClick={handleOnChange} />
      <div className="text-sm">{text}</div>
    </div>
  );
}
